import { Box, Button } from '@mantine/core'

import { useRemoteConfig } from '../api/RemoteConfigContext'
import { versionBelow } from '../api/remoteConfig'
import { APP_VERSION } from '../lib/version'
import { StatusBanner } from './StatusBanner'

/** `/config`'s maintenance notice (docs/plan/api.md "App config"), shown wherever `Layout` mounts so it's visible
 * from any signed-in page. */
export function MaintenanceBanner() {
  const config = useRemoteConfig()
  if (!config.maintenance) return null
  return (
    <Box mb="md">
      <StatusBanner tone={config.maintenance.level}>{config.maintenance.message}</StatusBanner>
    </Box>
  )
}

/** `/config`'s `minVersion.web` floor: this build is older, so ask for a reload rather than run on against a
 * server that may have moved past it (docs/plan/api.md "App config"). The server decides what "please update"
 * means; a fresh page load picks up whatever the deploy just shipped. */
export function UpdatePrompt() {
  const config = useRemoteConfig()
  if (!config.minVersion.web || !versionBelow(APP_VERSION, config.minVersion.web)) return null
  return (
    <Box mb="md">
      <StatusBanner
        tone="info"
        action={
          <Button size="compact-sm" variant="light" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      >
        A new version of Macrotide is available. Please reload to update.
      </StatusBanner>
    </Box>
  )
}
